import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProposalProvider } from './contexts/ProposalContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import { LoginPage } from './pages/LoginPage';
import { RequestAccessPage } from './pages/RequestAccessPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { SalesDashboard } from './pages/SalesDashboard';
import { CataloguePage } from './pages/CataloguePage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { ProductFormPage } from './pages/ProductFormPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { CollectionsPage } from './pages/CollectionsPage';
import { CollectionDetailPage } from './pages/CollectionDetailPage';
import { ProposalBuilderPage } from './pages/ProposalBuilderPage';
import { BulkImportPage } from './pages/BulkImportPage';
import { PDFImport } from './pages/PDFImport';
import { useAuth } from './contexts/AuthContext';
import './App.css';

const DashboardRouter = () => {
  const { user } = useAuth();
  
  if (!user) return null;
  
  return user.role === 'admin' ? <AdminDashboard /> : <SalesDashboard />;
};

function App() {
  return (
    <AuthProvider>
      <ProposalProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/request-access" element={<RequestAccessPage />} />
            
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardRouter />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/catalogue"
              element={
                <ProtectedRoute>
                  <CataloguePage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/products/:id"
              element={
                <ProtectedRoute>
                  <ProductDetailPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/products/new"
              element={
                <ProtectedRoute requireAdmin>
                  <ProductFormPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/products/edit/:id"
              element={
                <ProtectedRoute requireAdmin>
                  <ProductFormPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/users"
              element={
                <ProtectedRoute requireAdmin>
                  <UserManagementPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/collections"
              element={
                <ProtectedRoute>
                  <CollectionsPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/collections/:id"
              element={
                <ProtectedRoute>
                  <CollectionDetailPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/proposal"
              element={
                <ProtectedRoute>
                  <ProposalBuilderPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/bulk-import"
              element={
                <ProtectedRoute requireAdmin>
                  <BulkImportPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/pdf-import"
              element={
                <ProtectedRoute requireAdmin>
                  <PDFImport />
                </ProtectedRoute>
              }
            />
            
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </ProposalProvider>
    </AuthProvider>
  );
}

export default App;
